import React from 'react';
import { graphql, gql, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom'
import { Row, Col, Form, Input, Icon, Upload, message, Modal, Carousel } from 'antd';
import ImagesUploader from 'react-images-uploader';
import 'react-images-uploader/styles.css';
import 'react-images-uploader/font.css';
import axios from 'axios';
const FormItem = Form.Item;
const { TextArea } = Input;


class FormRegister extends React.Component {
      constructor(props) {
            super(props);
            this.state = {
                  previewVisible: false,
                  previewImage: '',
                  fileList: [],
            };
            this.renderForm = this.renderForm.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.isCustomerFilled = this.isCustomerFilled.bind(this);
            this.handleChange = this.handleChange.bind(this);
      }
      handleCancel = () => this.setState({ previewVisible: false })

      handlePreview = (file) => {
            this.setState({
                  previewImage: file.url || file.thumbUrl,
                  previewVisible: true,
            });
      }

      handleChange = ({ fileList }) => this.setState({ fileList })

      isCustomerFilled() {
            if (localStorage.is_filled) {
                  var a = (new Date());
                  var b = (new Date(localStorage.filled));
                  if (a.getDate() !== b.getDate()) {
                        return true;
                  } else
                        return false;
            }
      }
      componentWillReceiveProps(nextProps) {
            this.setState({ ip: nextProps.ip }, () => {
                  const that = this;
                  if (this.isCustomerFilled()) {
                        this.props.updateWhatCustomerSeeAfterFilledForm({
                              variables: {
                                    ip: that.state.ip,
                                    whatCustomerSee: 'closedForm'
                              }
                        })
                  }
            });
      }
      handleSubmit(e) {
            e.preventDefault();
            const that = this;

            const linkLogo = [];
            this.state.fileList.forEach(element => {
                  linkLogo.push(element.thumbUrl);
            });
            console.log("list", linkLogo);
            this.props.form.validateFields((err, values) => {
                  if (!err) {
                        this.props.sendRegister({
                              variables: {
                                    name: values.name,
                                    phone: values.phone,
                                    career: values.career,
                                    email: values.email,
                                    linkLogo: linkLogo,
                                    source:"tuvanlogo",
                                    description:values.description
                              }
                        }).then((data) => {
                              window.location.href = "/thank-you";
                        }).catch((error) => { })
                  }
            });
      }
      renderForm() {
            const { getFieldDecorator } = this.props.form;
            // const imageUrl = this.state.imageUrl;
            const { previewVisible, previewImage, fileList } = this.state;

            const uploadButton = (
                  <div className="upload-img">
                        <Icon type="upload" />
                        <div className="ant-upload-text">Tải logo</div>
                  </div>
            );
            return (
                  <Form className="form-content">
                        <FormItem>
                              <p>Họ tên</p>
                              {getFieldDecorator('name', {
                                    rules: [{ required: true, message: 'Nhập họ tên của bạn!' }],
                              })(
                                    <Input className="content-input" prefix={<Icon type="user" style={{ fontSize: 13 }} />} type="text" placeholder="Input" />
                                    )}
                        </FormItem>
                        <FormItem>
                              <p>Số điện thoại</p>
                              {getFieldDecorator('phone', {
                                    rules: [{ required: true, message: 'Nhập số điện thoại của bạn!' }],

                              })(
                                    <Input className="content-input" prefix={<Icon type="phone" style={{ fontSize: 13 }} />} type="number" placeholder="Input" />
                                    )}
                        </FormItem>
                        <FormItem>
                              <p>Email</p>
                              {getFieldDecorator('email', {
                                    rules: [{ required: true, message: 'Nhập email của bạn!' }],
                              })(
                                    <Input className="content-input" prefix={<Icon type="mail" style={{ fontSize: 13 }} />} type="email" placeholder="Input" />
                                    )}
                        </FormItem>
                        <FormItem>
                              <p>Nghề nghiệp</p>
                              {getFieldDecorator('career')(
                                    <Input className="content-input" prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="text" placeholder="Input" />
                              )}
                        </FormItem>
                        <FormItem>
                        {getFieldDecorator('logo', {
                                    rules: [{ required: true, message: 'Upload logo!' }],
                              })(
                              <Upload
                                    action="http://localhost:4050/services/notmultiple"
                                    // action="http://servertuvanlogo.uplevo.com/services/notmultiple"
                                    listType="picture-card"
                                    fileList={fileList}
                                    onPreview={this.handlePreview}
                                    onChange={this.handleChange}
                              >
                                    {fileList.length >= 3 ? null : uploadButton}
                              </Upload>)}
                              <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                              </Modal>
                              
                        </FormItem>
                       
                        <FormItem>
                              <p>Mong muốn</p>
                              {getFieldDecorator('description')(
                                    <TextArea className="content-input2" rows={2} prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="text" placeholder="Input" />
                              )}
                        </FormItem>
                        <FormItem>
                              <button onClick={this.handleSubmit} >
                                    ĐĂNG KÝ NGAY
                              </button>
                        </FormItem>
                  </Form>
            )
      }
      render() {
            return (
                  <div id="dang-ky" className="form-register-wrap">
                        {/* <Carousel autoplay>
                              <div><h3>1</h3></div>
                              <div><h3>2</h3></div>
                              <div><h3>3</h3></div>
                              <div><h3>4</h3></div>
                        </Carousel> */}
                        <Row type="flex" justify="space-around">
                              <Col lg={{ span: 12 }} md={{ span: 10 }} sm={{ span: 10 }}>
                                    <div className="content">
                                          <h2>TƯ VẤN MIỄN PHÍ</h2>
                                          <h4>LOGO VÀ THƯƠNG HIỆU CỦA BẠN</h4>
                                          <p>Đánh giá, góp ý bởi các Chuyên gia và Nhà thiết kế nhiều kinh nghiệm.</p>

                                    </div>
                                  

                              </Col>
                        </Row>
                        <Row className="form-register" gutter={16} type="flex" justify="space-around">

                              <Col lg={{ span: 8 }} md={{ span: 10 }} sm={{ span: 10 }}>
                                    {this.renderForm()}
                              </Col>
                        </Row>
                  </div>
            )
      }
}

const sendRegister = gql`
      mutation createContact($email: String, $name: String, $phone: String, $career: String,$linkLogo:[String],$description:String,$source:String){
            createContact(email: $email, name: $name, phone: $phone, career: $career, linkLogo:$linkLogo,description:$description,source:$source){
                  email, name
            }
      }
`


export default compose(
      graphql(sendRegister, { name: "sendRegister" })
)(withRouter(Form.create()(FormRegister)));


// WEBPACK FOOTER //
// ./src/components/App/FormRegister.js